import { render, staticRenderFns } from "./CoefficientOfVariation.vue?vue&type=template&id=3a5c1e9b&scoped=true&"
import script from "./CoefficientOfVariation.vue?vue&type=script&lang=js&"
export * from "./CoefficientOfVariation.vue?vue&type=script&lang=js&"
import style0 from "./CoefficientOfVariation.vue?vue&type=style&index=0&id=3a5c1e9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c1e9b",
  null
  
)

export default component.exports